import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isIconDisabled',
  standalone: true,
})
export class IsIconDisabledPipe implements PipeTransform {
  transform(newIcon: string, savedIcons: string[], previousIcon: string): boolean {
    return newIcon !== previousIcon && savedIcons.includes(newIcon);
  }
}
